var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWaitingTranslator = function SvgWaitingTranslator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#87AACA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.053 4.75a2.333 2.333 0 1 0 0 4.667H9.47A4.083 4.083 0 0 0 5.387 13.5c0 .644.522 1.167 1.166 1.167h7c.645 0 1.167-.523 1.167-1.167a4.083 4.083 0 0 0-4.083-4.083h-.584a2.333 2.333 0 0 0 0-4.667M8.887 7.083a1.167 1.167 0 1 1 2.333 0 1.167 1.167 0 0 1-2.333 0M6.553 13.5a2.917 2.917 0 0 1 2.917-2.917h1.167a2.917 2.917 0 0 1 2.916 2.917z",
    clipRule: "evenodd"
  })));
};
export default SvgWaitingTranslator;